
import Store from "@/store";
import App from "@/App.vue";

export default function checkForWebGL(params: IRouterContext) {
    // eslint-disable-next-line no-console
    //
    const nextParams: any = {
        path: "/video",
    };

    if (window.WEBGL.isWebGLAvailable() !== true) {
        if (params.from.path !== "/video" && params.to.path !== "/video") {
            return params.next(nextParams);
        }
    }

    // Proceed
    return params.next();
}
